<mat-card class="example-card">
  <mat-card-header class="py-8 bg-blue-900 text-white flex rounded-t-md">
    <div class="font-bold text-3xl">
      Menu restaurant
      <span *ngIf="selectedResto" class="text-yellow-400">{{
        selectedResto.Tiers_RS
      }}</span>
    </div>
  </mat-card-header>
  <mat-card-content class="border">
    <!------------ bare de chargement ----------------->

    <div *ngIf="exist; else attente"></div>
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>

    <div class="grid grid-rows-2 gap-4">
      <div class="col-span-2 row-span-5">
        <div
          class="relative flex flex-col rounded-xl bg-white bg-clip-border text-gray-700 shadow-md"
        >
          <div class="p-6">
            <div class="mb-4 flex items-center justify-between">
              <h5
                class="block font-sans text-xl font-semibold tracking-normal text-blue-gray-900"
                style="font-size: medium; font-weight: bold"
              >
                Restaurants
              </h5>
              <!-- <a
                class="block font-sans text-sm font-bold leading-normal text-blue-500 antialiased"
              >
                View all
              </a> -->
            </div>
            <div class="divide-y divide-gray-200">
              <div
                *ngFor="
                  let resto of menuRestoService.list_restaurants;
                  index as i
                "
                class="flex items-center justify-between pb-3 pt-3 last:pb-0"
                (click)="onClickOnResto(i, resto)"
              >
                <div class="flex items-center gap-x-3">
                  <!-- <img
                    src="https://demos.creative-tim.com/test/corporate-ui-dashboard/assets/img/team-1.jpg"
                    alt="Tania Andrew"
                    class="relative inline-block h-52 w-52 rounded-full object-cover object-center"
                  /> -->
                  <div
                    class="avatar-initials text-center flex flex-col justify-center"
                  >
                    {{ getInitials(resto.Tiers_RS) }}
                  </div>
                  <div>
                    <h6
                      class="block font-sans text-base font-semibold leading-relaxed tracking-normal text-blue-gray-900 antialiased"
                    >
                      {{ resto.Tiers_RS }}
                    </h6>
                    <p
                      class="block font-sans text-sm font-light leading-normal text-gray-700 antialiased"
                    >
                      {{ resto.Tiers_code }}
                    </p>
                  </div>
                </div>
                <h6
                  class="block font-sans text-base font-semibold leading-relaxed tracking-normal text-blue-gray-900 antialiased"
                >
                  {{ resto.Tiers_Ville }}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="col-span-3 col-start-3 mx-6 my-6 px-6 py-6 shadow-md rounded-md"
      >
        <form>
          <fieldset>
            <legend>Ajouter menu restaurant</legend>
            <mat-form-field
              appearance="outline"
              style="width: 100%"
              class="mx-2"
            >
              <mat-label>Menu code</mat-label>
              <input
                type="text"
                matInput
                class="bg-white"
                name="code_menu"
                placeholder="Menu code"
                [(ngModel)]="
                  menuRestoService.DS_menuRestaurant?.Menu_RestaurantD[0]
                    .Code_Menu
                "
              />
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              style="width: 100%"
              class="mx-2"
            >
              <mat-label>Menu Detail</mat-label>
              <textarea
                matInput
                name="Detail_Menu"
                placeholder="Ex. Menu Detail..."
                [(ngModel)]="
                  menuRestoService.DS_menuRestaurant?.Menu_RestaurantD[0]
                    .Detail_Menu
                "
              ></textarea>
            </mat-form-field>
            <mat-form-field
              appearance="outline"
              style="width: 100%"
              class="mx-2"
            >
              <mat-label>Menu Tarif</mat-label>
              <input
                type="number"
                matInput
                name="Menu_Tarif"
                placeholder="Menu Tarif"
                [(ngModel)]="
                  menuRestoService.DS_menuRestaurant?.Menu_RestaurantD[0]
                    .Menu_Tarif
                "
              />
            </mat-form-field>

            <div
              class="button-container"
              style="display: flex; justify-content: flex-end"
            >
              <button
                (click)="menuRestoService.saveMenu_Restaurant()"
                mat-raised-button
                class="colorGreen"
              >
                <mat-icon>save</mat-icon>
                Enregistrer
              </button>
            </div>
          </fieldset>
        </form>
      </div>
      <div class="col-span-3 row-span-4 col-start-3 row-start-2">
        <div
          class="container"
          *ngIf="
            menuRestoService.list_menu_byResto &&
            menuRestoService.list_menu_byResto.length > 0
          "
        >
          <ng-container *ngFor="let menu of menuRestoService.list_menu_byResto">
            <h3>
              <span>{{ menu.text }}</span>
              <span>{{ menu.value | currency : "TND" : "symbol" }}</span>
            </h3>
            <p>
              {{ menu.Detail_Menu }}
            </p>
          </ng-container>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
